import "./ReplaceArticle.scss";

import PropTypes from "prop-types";

import React from "react";
import { FormattedMessage } from "react-intl";
import SearchInput from "./../../../../general/SearchInput";
import SearchAction from "../../../../../actions/SearchAction";
import SearchStore from "../../../../../stores/SearchStore";
import { trackReplacementSearch } from "../../../../../utils/SearchTrackingUtil";
import { trackReplaceSearchLink, trackReplaceSearchLinkClose } from "shared/src/tracking/ListTrackingUtil";

import SearchResult from "../SearchResult";

import { Modal } from "react-bootstrap";
import { SearchQuery } from "shared/src/types/articlesearch/SearchResult";
import { PageType } from "shared/src/types/PageType";
import { ReplacementKindSearch } from "shared/src/tracking/Tracking";

export type ReplaceInfo = {
    oldVariantId: string;
    oldBundleId: string | undefined | null;
    bettyBundleId: string | undefined | null;
    listId: string;
    close: () => void;
};

// despite the name, this actually renders multiple items
class ReplaceListItem extends React.Component<any, { query: SearchQuery }> {
    static propTypes = {
        bettyVariantId: PropTypes.string.isRequired,
        bundleId: PropTypes.string.isRequired,
        listId: PropTypes.string.isRequired,
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool,
        artName: PropTypes.string,
        listOfArticles: PropTypes.array,
        pageType: PropTypes.any,
        children: PropTypes.any
    };

    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    IsArticlesSearchTracked: boolean = false;
    static Trigger: typeof ReplaceListItemModalTrigger;

    constructor(props: { [x: string]: any }) {
        super(props);
        const initialQuery: SearchQuery = {
            q: props.artName || "",
            categoryPath: undefined,
            facets: [],
            ranges: [],
            options: [],
            sorting: undefined,
            profile: undefined,
            searchPurpose: SearchStore.replacementPurpose
        };
        this.state = { query: initialQuery };
    }

    tryDoingQueryWithTracking() {
        if (!this.IsArticlesSearchTracked) {
            this.doQuery();
            this.IsArticlesSearchTracked = true;
        }
    }

    componentWillMount() {
        this.tryDoingQueryWithTracking();
    }

    componentWillReceiveProps() {
        this.tryDoingQueryWithTracking();
    }

    onQuery = (query: string) => {
        if (query && this.state.query.q !== query) {
            this.setState({ query: Object.assign({}, this.state.query, { q: query }) }, () => {
                this.doQuery();
            });
        }
    };

    doQuery = () => {
        const query = this.state.query;
        const newQuery: SearchQuery = {
            q: query.q || "*",
            categoryPath: query.categoryPath,
            facets: query.facets,
            ranges: query.ranges,
            options: query.options,
            sorting: query.sorting,
            profile: undefined,
            searchPurpose: SearchStore.replacementPurpose
        };
        const paginationState = this.context.router.location.state;
        SearchAction.query.trigger(newQuery, paginationState);
        trackReplacementSearch(query.q);
    };

    handleChangeQuery = (newQuery: SearchQuery) => {
        const location = this.context.router.location;
        const newState = Object.assign({}, location.state, { numPagesSearch: 1 });
        const newLocation = Object.assign({}, location, { state: newState });
        this.context.router.replace(newLocation);
        this.setState({ query: newQuery }, () => this.doQuery());
    };

    handleQueryLinkClick = (
        newQuery: SearchQuery,
        otherHandler: (ev: React.SyntheticEvent) => {},
        event: React.SyntheticEvent
    ) => {
        event.preventDefault();
        this.handleChangeQuery(newQuery);
        if (typeof otherHandler === "function") {
            otherHandler(event);
        }
    };

    renderQueryLink = (props: { query: SearchQuery; children: any; onClick: (ev: React.SyntheticEvent) => {} }) => {
        const { query, children, ...otherProps } = props;
        return (
            <a {...otherProps} href="#" onClick={(ev) => this.handleQueryLinkClick(query, props.onClick, ev)}>
                {children}
            </a>
        );
    };

    render() {
        const replace: ReplaceInfo = {
            oldVariantId: this.props.bettyVariantId,
            oldBundleId: this.props.bundleId,
            bettyBundleId: this.props.bundleId,
            listId: this.props.listId,
            close: this.props.onClose
        };

        return (
            <Modal
                bsSize="large"
                dialogClassName="ex-replace-article-modal mfcss"
                animation
                keyboard
                onHide={this.props.onClose}
                show={this.props.show}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage id="EX_REPLACE" />
                        {' "'}
                        {this.props.artName}
                        {'"'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="ex-confirm-modal">
                    <SearchInput
                        initialValue={this.state.query.q}
                        className="replace-article-search-input"
                        onQuery={this.onQuery}
                        placeholderId="SEARCH_PLACEHOLDER"
                    />
                    <SearchResult
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore -- used only for testing
                        className="replace-article-search-result"
                        query={this.state.query}
                        replace={replace}
                        listOfArticles={this.props.listOfArticles}
                        queryLinkComponent={this.renderQueryLink}
                        onChangeQuery={this.handleChangeQuery}
                        pageType={this.props.pageType}
                        replacementKind={ReplacementKindSearch}
                    />
                </Modal.Body>
            </Modal>
        );
    }
}

type Props = {
    bettyVariantId: string | undefined | null;
    bundleId: string | undefined | null;
    listId: string;
    artName: string | undefined | null;
    listOfArticles: Array<any> | undefined | null;
    children?: any;
    pageType: PageType;
};

class ReplaceListItemModalTrigger extends React.Component<
    Props,
    {
        showModal: boolean;
    }
> {
    static propTypes = {
        bettyVariantId: PropTypes.string,
        bundleId: PropTypes.string,
        listId: PropTypes.string.isRequired,
        artName: PropTypes.string,
        listOfArticles: PropTypes.array,
        children: PropTypes.node,
        pageType: PropTypes.any.isRequired
    };

    state = { showModal: false };

    close = () => {
        this.setState({ showModal: false });
        trackReplaceSearchLinkClose(this.props.bundleId, ReplacementKindSearch);
    };

    open = (event: React.SyntheticEvent) => {
        event.preventDefault();
        this.setState({ showModal: true });
        trackReplaceSearchLink(this.props.bundleId, ReplacementKindSearch);
        // Initial search for the article.
        SearchAction.query.trigger(
            {
                q: this.props.artName,
                searchPurpose: SearchStore.replacementPurpose
            },
            {
                numPagesSearch: 1
            }
        );
    };

    render() {
        let modal;
        if (this.state.showModal) {
            modal = <ReplaceListItem {...this.props} show={this.state.showModal} onClose={this.close} />;
        }
        return (
            <span className="ex-replace-articles">
                <a onClick={this.open}>{this.props.children}</a>
                {this.state.showModal && modal}
            </span>
        );
    }
}

ReplaceListItem.Trigger = ReplaceListItemModalTrigger;

export default ReplaceListItem;
export { ReplaceListItemModalTrigger as Trigger };
